import { useEffect, useRef, useState } from 'react'

import Carousel from 'react-multi-carousel'

import { scrollToCarouselElementWithOffset } from '../../../../utils/helper-util'
import { getAttributeValue, hasCFConditionals } from '../../../../utils/rule-builder-util'
import CustomDot from '../../CustomDot'
import { ImageryContentFragment, responsiveCarouselProps } from '../../types'
import ReactImageCarouselItemSmall from '../ReactImageCarouselItemSmall'
import { ImageCarouselProps } from '../types'

interface CarouselRef {
  goToSlide: (slide: number) => void
}
const ReactImageCarouselSmallScreen = (props: ImageCarouselProps) => {
  const {
    carouselItems = [],
    ruleExpression = '',
    ruleType,
    condition,
    activePip,
    inActivePip,
    activePipAltText,
    inActivePipAltText,
    tokenProperties,
    selectedSlideId,
    resetSlideId,
    flexOffers
  } = props
  const [items, setItems] = useState<any>([])

  useEffect(() => {
    setTimeout(() => {
      setItems(carouselItems)
    }, 0)
  })
  const [placardHeight, setPlacardHeight] = useState(0)
  const placardRef = useRef([])
  const slideIdMap = new Map()
  const carouselRef = useRef<CarouselRef | any>(null)
  useEffect(() => {
    setTimeout(() => {
      const cardHeights = placardRef.current.map((ref: any) => ref.offsetHeight)
      const maxCardHeight = Math.max(...cardHeights)
      setPlacardHeight(maxCardHeight)
    }, 1000)
  }, [])

  useEffect(() => {
    if (selectedSlideId) {
      const index = slideIdMap.get(selectedSlideId)
      if (index > -1) {
        scrollToCarouselElementWithOffset({}, '#', selectedSlideId)
        carouselRef?.current?.goToSlide(index)
      }
    }
    return () => {
      resetSlideId?.()
    }
  }, [selectedSlideId])

  return (
    <div className='react-image-carousel-small-screen'>
      <Carousel
        ref={carouselRef}
        responsive={responsiveCarouselProps}
        arrows={false}
        showDots={true}
        renderDotsOutside={true}
        swipeable={true}
        customDot={
          <CustomDot
            activePip={activePip}
            inActivePip={inActivePip}
            activePipAltText={activePipAltText}
            inActivePipAltText={inActivePipAltText}
          />
        }
      >
        {items?.map((item: ImageryContentFragment, index: number) => {
          const getValue = (attribute: any, propertyName?: string) => {
            if (hasCFConditionals(attribute)) {
              const jsonAttribute = (props as any)?.[`${propertyName}_json`]
              return getAttributeValue(jsonAttribute, flexOffers, index, tokenProperties, propertyName)
            }
            return getAttributeValue(attribute, flexOffers, index, tokenProperties, propertyName)
          }
          const slideIdToSet = item?.elements.contentFragmentId?.value
            ? getValue(item?.elements.contentFragmentId, 'contentFragmentId')
            : getValue(item?.id, 'id')

          slideIdMap.set(slideIdToSet, index)
          return (
            <ReactImageCarouselItemSmall
              ref={placardRef}
              index={index}
              minPlacardHeight={placardHeight}
              key={`${item.id}_image`}
              {...item.elements}
              ruleExpression={ruleExpression}
              ruleType={ruleType}
              condition={condition}
              tokenProperties={tokenProperties}
              id={item?.id}
            />
          )
        })}
      </Carousel>
    </div>
  )
}

export default ReactImageCarouselSmallScreen
